//Margin conventions
var margin = {top: 5, right: 92, bottom: 22, left: 28};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 300 - margin.top - margin.bottom;

//Parses date for correct time format
var parseDate = d3.time.format("%Y").parse;  

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
	.attr("width", width + margin.left + margin.right)
	.attr("height", height + margin.top + margin.bottom)
	.append("g")
	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.time.scale()
  .range([0, width]);

//Creates the yScale
var yScale = d3.scale.linear()
  .range([height, 0]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
	.scale(yScale)
  .tickSize(-width)
  .tickPadding(6)
  .ticks(5)
  .tickFormat(function(d) { return "$" + d; })
	.orient("left");

//Defines the y axis styles
var xAxis = d3.svg.axis()
	.scale(xScale)
  .tickPadding(6)
	.orient("bottom")
  .ticks(4)
  .tickFormat(d3.time.format("%Y")); 

//line function convention (feeds an array)
var line = d3.svg.line()
  .x(function(d) { return xScale(d.date); })
  .y(function(d) { return yScale(d.amount); }); 

//Loads the data
d3.csv("data/wagesByEd.csv", ready);

function ready(err, data) {

	if (err) throw "error loading data";

	//FORMAT data
	data.forEach(function(d) {
		d.amount = +d.amount;
    d.date = parseDate(d.date);
	});
	
	//Organizes the data	
  data.sort(function(a,b) { return a.date - b.date; });
  var maxY = d3.max(data, function(d) { return d.amount; });
  var maxX = d3.max(data, function(d) { return d.date; });

  //Nest the data
  var dataByCategory = d3.nest()
    .key(function(d) { return d.category;})
    .entries(data);

  console.log(dataByCategory);  

  //Defines the xScale max
  xScale.domain(d3.extent(data, function(d) { return d.date; }));

  //Defines the yScale max
  yScale.domain([0, maxY]);

	//Appends the y axis
	var yAxisGroup = svg.append("g")
		.attr("class", "y axis")
		.call(yAxis)
		.selectAll("g")
		.classed("g-baseline", function(d) {return d == 0});

	//Appends the x axis		
	var xAxisGroup = svg.append("g")
		.attr("class", "x axis")
		.attr("transform", "translate(0," + height + ")")
		.call(xAxis);   

  //Binds the data to the line
  var drawline = svg.selectAll(".cat-path")
    .data(dataByCategory)
    .enter()
    .append("path")
    .attr("class", "cat-path")
    .attr("d", function(d) { return line(d.values) })
    .classed("lessThanHS-line", function(d) { return d.key == "lessThanHS"; })
    .classed("HS-line", function(d) { return d.key == "HS"; })
    .classed("someCollege-line", function(d) { return d.key == "someCollege"; })
    .classed("bachDeg-line", function(d) { return d.key == "bachDeg"; }) 
    .classed("adDeg-line", function(d) { return d.key == "adDeg"; }); 

  //Append labels  
  var lessthanHSlabel = svg.append("text")
      .text("Less than H.S.")
      .attr("class", "lessThanHS-label")
      .attr("x", width/1)
      .attr("y", height/1.45)
      .attr("transform", "translate(5,0)");   

  var HSlabel = svg.append("text")
      .text("High school")
      .attr("class", "HS-label")
      .attr("x", width/1)
      .attr("y", height/1.65)
      .attr("transform", "translate(5,0)");    

  var someCollegelabel = svg.append("text")
      .text("Some college")
      .attr("class", "someCollege-label")
      .attr("x", width/1)
      .attr("y", height/1.87)
      .attr("transform", "translate(5,0)");

  var bachDeglabel = svg.append("text")
      .text("Bachelor's deg.")
      .attr("class", "bachDeg-label")
      .attr("x", width/1)
      .attr("y", height/4.2)
      .attr("transform", "translate(5,0)");  

  var adDeglabel = svg.append("text")
      .text("Advanced deg.")
      .attr("class", "adDeg-label")
      .attr("x", width/1)
      .attr("y", height/40)
      .attr("transform", "translate(5,0)");                  	

//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 5, right: 92, bottom: 22, left: 28};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Update the line
    line = d3.svg.line()
      .x(function(d) { return xScale(d.date); })
      .y(function(d) { return yScale(d.amount); }); 

    d3.selectAll('.cat-path')
      .attr("d", function(d) { return line(d.values) }) 

    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale)
      .ticks(4);

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);

    lessthanHSlabel
      .attr("x", newWidth/1);  

    HSlabel
      .attr("x", newWidth/1); 

    someCollegelabel
      .attr("x", newWidth/1); 

    bachDeglabel
      .attr("x", newWidth/1);     

    adDeglabel
      .attr("x", newWidth/1);      
  };

}